import React from "react";

const URL_RE = /(https?:\/\/[^\s]+)/g;

// Renders plain text with URLs as clickable links (opens in a new tab).
export const Linkify = ({ text, className }) => {
  const parts = String(text || "").split(URL_RE);
  return (
    <span className={className}>
      {parts.map((p, i) => URL_RE.test(p)
        ? <a key={i} href={p} target="_blank" rel="noreferrer" className="text-primary underline break-all" onClick={(e) => e.stopPropagation()}>{p}</a>
        : <React.Fragment key={i}>{p}</React.Fragment>)}
    </span>
  );
};
